import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(regionId, email) {
  return yield oncallFetch("/api/oncall/partners/regions/emails/remove", {
    regionId,
    email,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/emails/remove.js